var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Close } from '@amsterdam/asc-assets';
import React, { useState } from 'react';
import CompactThemeProvider from '../../theme/CompactThemeProvider';
import Paragraph from '../Paragraph';
import AlertStyle, { AlertHeading, CloseButton, CloseButtonWrapper, ContentWrapper, } from './AlertStyle';
const CLOSE_BUTTON_TITLE = 'Sluiten';
const Alert = (_a) => {
    var { children, content, dismissible, heading, level, onDismiss, outline } = _a, otherProps = __rest(_a, ["children", "content", "dismissible", "heading", "level", "onDismiss", "outline"]);
    const [open, setOpen] = useState(true);
    let variant = 'tertiary';
    if (outline) {
        variant = 'blank';
    }
    else if (level === 'error') {
        variant = 'secondary';
    }
    else if (level === 'info') {
        variant = 'primary';
    }
    const handleOnDismiss = () => {
        setOpen(false);
        if (onDismiss) {
            onDismiss();
        }
    };
    return open ? (React.createElement(AlertStyle, Object.assign({}, Object.assign({ dismissible, level, outline }, otherProps), { tabIndex: 0, role: "alert", "aria-live": "polite" }),
        React.createElement(CompactThemeProvider, null,
            React.createElement(ContentWrapper, null,
                heading && (
                // @ts-ignore
                React.createElement(AlertHeading, { forwardedAs: "strong", styleAs: "h3" }, heading)),
                content && React.createElement(Paragraph, null, content),
                children),
            dismissible && (React.createElement(CloseButtonWrapper, null,
                React.createElement(CloseButton, { title: CLOSE_BUTTON_TITLE, "aria-label": CLOSE_BUTTON_TITLE, size: 30, variant: variant, onClick: handleOnDismiss, iconSize: 20, icon: React.createElement(Close, null) })))))) : null;
};
export default Alert;
//# sourceMappingURL=Alert.js.map